export default {
    STRIPE_PUBLISHABLE_KEY: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    COLLECTION_BOOKINGS_REF: process.env.REACT_APP_COLLECTION_BOOKINGS_REF,
    COLLECTION_BOOKING_DATES_REF: process.env.REACT_APP_COLLECTION_BOOKING_DATES,
    API_GATEWAY_URL: process.env.REACT_APP_API_GATEWAY_URL,
    SLACK_WEBHOOK_URL: process.env.REACT_APP_SLACK_WEBHOOK_URL,
    PRODUCTION: process.env.REACT_APP_PRODUCTION,
    MAINTENANCE_MODE: process.env.REACT_APP_MAINTENANCE_MODE,
};
